module.exports = __webpack_public_path__ + "img/long_island_iced_tea.9408f077.jpg";